/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressFromJSON, AddressToJSON, } from './Address';
import { GeoLocationFromJSON, GeoLocationToJSON, } from './GeoLocation';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { NamedResourceTagFromJSON, NamedResourceTagToJSON, } from './NamedResourceTag';
/**
 * Check if a given object implements the LocationResponse interface.
 */
export function instanceOfLocationResponse(value) {
    var isInstance = true;
    isInstance = isInstance && "active" in value;
    return isInstance;
}
export function LocationResponseFromJSON(json) {
    return LocationResponseFromJSONTyped(json, false);
}
export function LocationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(NamedResourceTagFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'geoLocation': !exists(json, 'geoLocation') ? undefined : GeoLocationFromJSON(json['geoLocation']),
        'networkId': !exists(json, 'networkId') ? undefined : json['networkId'],
        'active': json['active'],
        'nielsenArea': !exists(json, 'nielsenArea') ? undefined : json['nielsenArea'],
        'referenceId': !exists(json, 'referenceId') ? undefined : json['referenceId'],
        'provider': !exists(json, 'provider') ? undefined : json['provider']
    };
}
export function LocationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'metaData': MetaDataToJSON(value.metaData),
        'tags': value.tags === undefined ? undefined : (value.tags.map(NamedResourceTagToJSON)),
        'id': value.id,
        'address': AddressToJSON(value.address),
        'geoLocation': GeoLocationToJSON(value.geoLocation),
        'networkId': value.networkId,
        'active': value.active,
        'nielsenArea': value.nielsenArea,
        'referenceId': value.referenceId,
        'provider': value.provider
    };
}
